import Condition from 'components/form/condition';
import * as T from 'prop-types';
import { Field } from 'react-final-form';
import { useTranslation } from 'react-i18next';
import { useAsync } from 'react-use';
import Api from 'service';

import { Box, Label, SelectFilter } from '@olist/united';

const SelectIntegratorField = ({ label, name }) => {
  const { t } = useTranslation();

  const integratorsOptionsData = useAsync(Api.getIntegratorsList, []);
  const { error, loading, value } = integratorsOptionsData;

  if (error || loading || !value) return null;

  const { integrators } = value;

  if (!integrators) return null;

  return (
    <Box width="100%">
      <Field name={name}>
        {({ input: { onChange } }) => {
          return (
            <Condition when="is_already_online_seller" is="1">
              <Box m="5px">
                <Label>{label}</Label>
                <Box height="44px">
                  <SelectFilter
                    autoFocus
                    options={integrators}
                    placeholder={t`select the platform`}
                    name={name}
                    onOptionChange={({ value: optionValue }) => onChange(optionValue)}
                    noOptionsMsg=""
                  />
                </Box>
              </Box>
            </Condition>
          );
        }}
      </Field>
    </Box>
  );
};

SelectIntegratorField.propTypes = {
  label: T.string.isRequired,
  name: T.string.isRequired,
};

export default SelectIntegratorField;
